import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { AuthProvider } from '@/api/AuthContext'
import ErrorBoundary from '@/components/ErrorBoundary'
import App from './App'
import './index.css'
import { startVersionCheck } from './versionCheck'

// Eski önbelleğe sabitlenen istemcileri otomatik onar (yalnızca üretimde)
if (import.meta.env?.PROD) {
  startVersionCheck()
}

// React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 dakika
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Demo veri tohumlama — YALNIZCA yerel geliştirmede (DEV) ve Supabase
// bağlı DEĞİLKEN. Canlıda (Supabase) asla çalışmaz; böylece gerçek veriye
// yanlışlıkla demo kayıt yazma riski tamamen ortadan kalkar.
if (import.meta.env?.DEV && !import.meta.env?.VITE_SUPABASE_URL) {
  import('@/api/_seedData').then(({ autoSeedIfEmpty }) => autoSeedIfEmpty())
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary label="Die Anwendung">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <TooltipProvider>
              <App />
              <Toaster position="top-right" richColors />
            </TooltipProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
